import { Alert } from "react-bootstrap";

interface UserPortalAlertProps {
    varient: string;
    title?: string;
    heading?: string;
    text: string;
    onCloseFn: () => void;
}

export const UserPortalAlert = (props:UserPortalAlertProps) => {

    return (
        <Alert
            style={{position:"absolute", top:"75px", right:"10px"}}
            variant={props.varient}
            dismissible={true} 
            show={true}
            onClose={() => props.onCloseFn()}
            transition={true}
            title={props.title}
        >
            <Alert.Heading>{props.heading}</Alert.Heading>
            <p>{props.text}</p>
        </Alert>
    )
}

export default UserPortalAlert;